import { Hero } from "@/components/Hero";
import { ClientProof } from "@/components/ClientProof";
import { WhoFor } from "@/components/WhoFor";
import { Outcomes } from "@/components/Outcomes";
import { Methodology } from "@/components/Methodology";
import { CaseStudies } from "@/components/CaseStudies";
import { ReadinessCheckBanner } from "@/components/ReadinessCheckBanner";
import { CoachingPlan } from "@/components/CoachingPlan";
import { About } from "@/components/About";
import { Objections } from "@/components/Objections";
import { FinalCTA } from "@/components/FinalCTA";
import { PageMeta } from "@/components/PageMeta";
import { ExitIntentPrompt } from "@/components/ExitIntentPrompt";
import { ROUTES } from "@/config/links";

/**
 * The High-Stakes Presentation Coaching page.
 * Route: /executive-coaching/high-stakes-presentation-coaching
 * (The site's homepage "/" is a separate page — <Home /> — and is not
 * touched by this rebuild.)
 *
 * All site chrome (Nav / Footer / Sticky CTA / Consent Banner / Lenis smooth-
 * scroll / notebook SVG defs) is provided by <SiteLayout />.
 *
 * The approved 10-section content spec, plus one extra promotional
 * banner added afterwards at the user's explicit request (between
 * sections 6 and 7 — dedicated Readiness Check CTA, green background):
 *  1. Hero            — Hero
 *  2. Client proof    — ClientProof (static, Marilena — no logos/carousel/video)
 *  3. Suitability     — WhoFor
 *  4. What we prepare  — Outcomes
 *  5. The method      — Methodology
 *  6. Client story + video — CaseStudies (Pantelis text case + Marilena video)
 *     — Readiness Check banner — ReadinessCheckBanner (added after initial launch)
 *  7. Coaching plan    — CoachingPlan
 *  8. Coach            — About
 *  9. FAQ              — Objections
 * 10. Final CTA        — FinalCTA (+ global Footer from SiteLayout)
 */
export default function Landing() {
  return (
    <>
      <PageMeta
        titleKey="meta.hspc_title"
        descriptionKey="meta.hspc_description"
        path={ROUTES.highStakesPresentationCoaching}
      />
      <Hero />
      <ClientProof />
      <WhoFor />
      <Outcomes />
      <Methodology />
      <CaseStudies />
      <ReadinessCheckBanner />
      <CoachingPlan />
      <About />
      <Objections />
      <FinalCTA />
      <ExitIntentPrompt />
    </>
  );
}
